// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-54ebe3a3] .callout-container {\n  background: #fff !important;\n  border-top: 1px solid #E2E2E2 !important;\n  border-right: 1px solid #E2E2E2 !important;\n  border-bottom: 1px solid #E2E2E2 !important;\n  border-left-width: 4px !important;\n}\n[data-v-54ebe3a3] .outline-success {\n  padding-left: 0px;\n}\n[data-v-54ebe3a3] .outline-success i {\n  font-size: 20px;\n  padding-left: 8px;\n  padding-right: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
